import { CryoTracker } from "../components/CryoTracker";
import { Container, createRoot } from "react-dom/client";

const root = createRoot(document.getElementById("root") as Container);

root.render(<CryoTracker />);
